module.exports = __webpack_public_path__ + "img/home-banner-ask-specialist-gr.27df2b8b.jpg";